import styles from './SectionCard.module.scss';

function SectionCard(props) {
  const { image, title, content, imagePosition = 'left', cardColor, isDark, imageBackdrop } = props;

  if (imagePosition === 'right') {
    return (
      <div className={styles.sectionContainerRight}>
        <div className="flex flex-col !w-full sm:w-1/2">
          <div
            className={styles.rightContentWrapper}
            style={{ backgroundColor: cardColor, color: isDark ? 'white' : 'inherit' }}
          >
            {content.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key -- static marketing content list, never reordered
              <div key={index} className={styles.descriptionWrapper}>
                <h3 className="!font-bold text-shadow-sm">{item.title}</h3>
                <p className={`${styles.truncate} !font-medium text-shadow-sm`} title={item.description}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col relative !w-full sm:w-1/2">
          <div className={`${imageBackdrop ? styles.rightbackdropWrapper : styles.rightImageWrapper}`}>
            <img className="w-full h-full object-cover" src={image} alt={title} />
            <div className={styles.imageOverlay} />
            <h2 className={styles.h2}>{title}</h2>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.sectionContainerLeft}>
      <div className="flex flex-col relative !w-full sm:w-1/2">
        <div className={`${imageBackdrop ? styles.leftbackdropWrapper : styles.leftImageWrapper}`}>
          <img className="w-full h-full object-cover" src={image} alt={title} />
          <div className={styles.imageOverlay} />
          <h2 className={styles.h2}>{title}</h2>
        </div>
      </div>
      <div className="flex flex-col relative !w-full sm:w-1/2">
        <div
          className={`${styles.leftContentWrapper}`}
          style={{ backgroundColor: cardColor, color: isDark ? 'white' : 'inherit' }}
        >
          {content.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key -- static marketing content list, never reordered
            <div key={index} className={styles.descriptionWrapper}>
              <h3>{item.title}</h3>
              <p className={styles.truncate}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionCard;
